var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.327,
    height: 43.536,
    viewBox: "0 0 31.327 43.536",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "np_padlock_3784969_000000",
    transform: "translate(-18.199 -5.801)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M43.509,23.146H24.223c-.079,0-.148.01-.227.015V17.794a9.87,9.87,0,1,1,19.74,0,1.061,1.061,0,1,0,2.122,0,11.995,11.995,0,0,0-23.99,0v5.837A6.013,6.013,0,0,0,18.2,29.161V43.32a6.028,6.028,0,0,0,6.023,6.018H43.509a6.024,6.024,0,0,0,6.018-6.018V29.161a6.019,6.019,0,0,0-6.018-6.014ZM47.4,43.319a3.893,3.893,0,0,1-3.89,3.9H24.223a3.894,3.894,0,0,1-3.9-3.9V29.16a3.889,3.889,0,0,1,3.9-3.89H43.509a3.892,3.892,0,0,1,3.89,3.89Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M48.858,55.391H45.622a1.065,1.065,0,0,0-1.064,1.064v7.432a1.065,1.065,0,0,0,1.064,1.064h3.236a1.069,1.069,0,0,0,1.064-1.064V56.455a1.069,1.069,0,0,0-1.064-1.064Zm-1.064,7.436H46.686V57.519H47.8v5.308Z",
    transform: "translate(-13.377 -25.167)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.8d55e9b06496c9bb25d91e7fe9dd6ce3.svg";
export { ForwardRef as ReactComponent };